import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import CostCentersList from 'cost_centers/components/list';
import { createRoute } from 'lib/util';

const { Form } = Common;

const CostCentersListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  subcompany = {},
  columnSearch, // Cambiar por redux
  handleToggle = () => {}, ///////
  handleToggleSearch = () => {}, // Agregar
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      {/* <CostCentersList.Header
        companyId={company.id}
        subcompanyId={subcompany.id}
        canAdd={permissions["acl.cost_centers.add"]}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('menu.configuration') + ' > ' + t('costCenters.costCenters_title')}
          icon={'book'}
          button={
            <div className="btn-group pull-right">
              {permissions['acl.cost_centers.add'] && (
                <Form.Link
                  to={createRoute(company.id, subcompany.id, 'cost_centers/add')}
                  className="btn btn-info"
                >
                  {t('actions.add')}
                </Form.Link>
              )}
            </div>
          }
          buttonTwo={
            <CostCentersList.Filters
              handleSubmit={handleSubmit}
              columnSearch={columnSearch}
              handleToggleSearch={handleToggleSearch}
              handleValueChange={handleFiltersChange}
              values={filters}
            />
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <CostCentersList.Table
              company={company} ////////
              subcompany={subcompany} ///////////
              permissions={permissions} ///////
              handleToggle={handleToggle} //////////
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </CostCentersList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(CostCentersListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/components/CostCentersListView.js